import { render, staticRenderFns } from "./Footers.vue?vue&type=template&id=d4a9b3ac&scoped=true&"
import script from "./Footers.vue?vue&type=script&lang=js&"
export * from "./Footers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4a9b3ac",
  null
  
)

export default component.exports